const language = {
    state: {
        // 当前语言类型
         currentLanguage: 'zh',
    },

    mutations: {
        SET_CURRENT_LANGUAGE: (state, currentLanguage) => {
            state.currentLanguage = currentLanguage
        },
    },

    actions: {
        setCurrentLanguage({ commit }, currentLanguage) {
            commit('SET_CURRENT_LANGUAGE', currentLanguage)            
        },
    }
}

export default language
